import { Link } from "react-router-dom";
import clsx from "clsx";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { CheckoutStepsEnum } from "@/constants/enums";

//#region Types
interface CheckoutStepsProps {
  currentStep: CheckoutStepsEnum;
}
//#endregion

const allStepItems = [
  { label: "購物車", step: CheckoutStepsEnum.CART },
  { label: "結帳", step: CheckoutStepsEnum.CHECKOUT },
  { label: "前往付款", step: CheckoutStepsEnum.PAYMENT },
  { label: "完成訂購", step: CheckoutStepsEnum.COMPLETE },
];

const CheckoutSteps = ({ currentStep }: CheckoutStepsProps) => (
  <section className="py-4 lg:py-8">
    <ul className="brand-text-sm brand-container lg:brand-text-md flex max-w-screen-md items-center justify-center gap-2 text-neutral lg:gap-4">
      {allStepItems.map((item, index) => {
        return (
          <StepItem
            key={item.step}
            label={item.label}
            step={item.step}
            currentStep={currentStep}
            isActive={currentStep === item.step}
            isLastStep={index >= allStepItems.length - 1}
          />
        );
      })}
    </ul>
  </section>
);

const StepItem = ({
  label,
  step,
  currentStep,
  isActive,
  isLastStep,
}: {
  label: string;
  step: CheckoutStepsEnum;
  currentStep: CheckoutStepsEnum;
  isActive: boolean;
  isLastStep: boolean;
}) => {
  return (
    <>
      <li
        className={clsx(isActive && "font-bold text-accent underline underline-offset-4", {
          is_active: isActive,
        })}
      >
        {currentStep === CheckoutStepsEnum.CHECKOUT && step === CheckoutStepsEnum.CART ? (
          <Link to="/cart" className="underline underline-offset-4">
            {label}
          </Link>
        ) : (
          label
        )}
      </li>
      {!isLastStep && <ArrowRightIcon className="size-4" />}
    </>
  );
};

export default CheckoutSteps;
